// Modules
import Common from "./modules/common";
// import Lightbox from "./modules/lightbox";
import FAQ from "./modules/faq";
import QCF from "./modules/qcf";

// Autoload modules
const modules = [Common, FAQ, QCF];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/Router";
import singlePost from "./partials/single-post";
import singleProperty from "./partials/single-property";
import templateAbout from "./partials/template-about";
import templateContacts from "./partials/template-contacts";
import templateHome from "./partials/template-home";
import templateNews from "./partials/template-news";
import templateProperties from "./partials/template-properties";
import templateSidebar from "./partials/template-sidebar";

// Populate Router instance with DOM routes
const routes = new Router({
  singlePost,
  singleProperty,
  templateAbout,
  templateContacts,
  templateHome,
  templateNews,
  templateProperties,
  templateSidebar,
});

// Load Events
$(document).ready(() => routes.loadEvents());
